import { useEffect, useState, useRef } from 'react';

const useElementSiblingWatcher = (element, shouldBeComputed, computeState) => {
  const [computedState, setComputedState] = useState(() => computeState(element));
  const shouldBeComputedRef = useRef(shouldBeComputed);
  const computeStateRef = useRef(computeState);
  const previousConditionRef = useRef(shouldBeComputed(element));

  useEffect(() => {
    shouldBeComputedRef.current = shouldBeComputed;
    computeStateRef.current = computeState;
  });

  useEffect(() => {
    if (!element || !element.parentElement) return Function.prototype;

    const parent = element.parentElement;

    let observer = new MutationObserver(() => {
      const nextConditionState = shouldBeComputedRef.current(element);

      if (nextConditionState !== previousConditionRef.current) {
        previousConditionRef.current = nextConditionState;
        setComputedState(computeStateRef.current(element));
      }
    });

    observer.observe(parent, { childList: true });

    return () => {
      observer.disconnect();
      observer = null;
    };
  }, [element]);

  return computedState;
};

export default useElementSiblingWatcher;
